var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{attrs:{"title":_vm.$t('trade.order-trail2-price-gap-label')}},[_c('PlusMinusInput',{attrs:{"precision":_vm.precision,"step":_vm.minTick,"min":0,"max":999999999,"match-tick":true,"match-precision":true},model:{value:(_vm.trailingPrice),callback:function ($$v) {_vm.trailingPrice=$$v},expression:"trailingPrice"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }